import React from 'react';

import { useTranslationX } from 'i18n';
import { TableData } from 'components/containers';
import TotalLabel from '../TotalLabel/TotalLabel';

import styles from './Financial.module.scss';

const Travels = () => {
  const { tx, t } = useTranslationX('travels', 'proposal');

  return (
    <div className={styles.financial}>
      <div style={{ display: 'flex' }}>
        <TotalLabel tableName="viagens" columnName="valorDiaria" title={tx('hotel')} />
        <TotalLabel tableName="viagens" columnName="valorPassagem" title={tx('ticket')} />
      </div>

      <div className={styles.table}>
        <TableData
          name="viagens"
          textSize="small"
          style={{ table: { minWidth: 680, maxWidth: 1000 } }}
          config={[
            {
              title: t('financial.description'),
              field: 'descricao',
              align: 'left',
              weight: 2,
            },
            {
              title: t('financial.month'),
              field: 'mesExecucao',
              fieldProps: { align: 'center' },
              align: 'center',
              weight: 1,
            },
            {
              title: tx('value-hotel'),
              field: 'valorDiaria',
              fieldProps: { align: 'right' },
              align: 'right',
              weight: 1,
            },
            {
              title: tx('value-ticket'),
              field: 'valorPassagem',
              fieldProps: { align: 'right' },
              align: 'right',
              weight: 1.5,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default Travels;
